<isp-checkbox
  [id]="id"
  [name]="key"
  [minus]="props.isMixed$ | async"
  [labelPosition]="props.labelPosition"
  [toggle]="props.toggle"
  [formControl]="formControl"
  [captionOn]="(props.captions$ | async).captionOn"
  [captionOff]="(props.captions$ | async).captionOff"
  [colorOn]="props.colorOn"
  [colorOff]="props.colorOff"
  [formlyAttributes]="field"
  [required]="props.required"
></isp-checkbox>
